import { toApiFullLandingPageLink } from '@storefronts/common-types'
import { useContext } from 'react'
import { ViddyLPContext } from '../../../context/viddyLPContext'
import { ReviewsSummary } from '../reviews/Reviews'
import { SectionContainer } from './Shared'
import { ScrollingLayout } from '../../../style/scrollingLayout'

export const ReviewSectionSummary: React.FC = () => {
    const { landingPage } = useContext(ViddyLPContext)
    const lpLink = toApiFullLandingPageLink(landingPage.landingPageLinks[0])
    if (!lpLink) return null
    return (
        <SectionContainer maxContentWidth={ScrollingLayout.PROSE_MAX_WIDTH}>
            <ReviewsSummary lpLink={lpLink} />
        </SectionContainer>
    )
}
